import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Divider, Box, Link } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  label: {
    padding: theme.spacing(1),
    backgroundColor: '#eee',
    color: '#5e6469',
    fontSize: 14,
    marginTop: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(1, 2),
  },
  body: {
    whiteSpace: 'pre-wrap',
    maxHeight: 300,
    overflow: 'auto',
    fontFamily: 'monospace',
    fontSize: 13,
  },
  warning: {
    color: 'red',
  },
}));

const MailPreview = ({ mailMagazine }) => {
  const classes = useStyles();
  const { subject, body, attachment_files } = mailMagazine;
  const containsTestUrl = body && (body.includes('staging.') || body.includes('webtest.'));

  return (
    <Paper className={classes.root} variant="outlined">
      <Typography variant="h6">メールプレビュー</Typography>
      <Divider />

      {containsTestUrl && (
        <Typography className={classes.warning}>
          テスト用のURLが含まれています。本番用のURLに変更してください。
        </Typography>
      )}

      <Typography className={classes.label}>タイトル</Typography>
      <Typography variant="subtitle1" className={classes.content}>
        {subject}
      </Typography>

      {attachment_files && attachment_files.length > 0 && (
        <>
          <Typography className={classes.label}>添付ファイル</Typography>
          <Box className={classes.content}>
            {attachment_files.map((af, idx) => (
              <div key={idx}>
                <Link href={af.url} target="_blank" rel="noopener">
                  {af.filename || af.url}
                </Link>
              </div>
            ))}
          </Box>
        </>
      )}

      <Typography className={classes.label}>本文</Typography>
      <Box className={classes.content}>
        <pre className={classes.body}>{body}</pre>
      </Box>
    </Paper>
  );
};

MailPreview.propTypes = {
  mailMagazine: PropTypes.shape({
    subject: PropTypes.string,
    body: PropTypes.string,
    attachment_files: PropTypes.array,
  }).isRequired,
};

export default MailPreview;
